"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _chai = require("chai");

/**
 * Perform pre/post guarding in your class
 */
class Guard {
  /**
   * The @{target} provided should not be null
   * @param {*} target target to check for a null value
   * @param {String} paramName the name of the @{target} object for the error message
   */
  static requiresNotNull(target, paramName) {
    (0, _chai.expect)(target, `${paramName} cannot be null`).not.to.be.null;
  }
  /**
   * Check for a particular condition in a callback
   * @param {function, boolean} input should either be true or return true
   * @param {string} reason the reason to specify to the developer for the failure given the condition fails
   */


  static requires(input, reason) {
    if (typeof input === 'function') {
      // function
      (0, _chai.expect)(input(), reason).to.be.true;
    } else {
      // literal
      (0, _chai.expect)(input, reason).to.be.true;
    }
  }

}

exports.default = Guard;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@vigilantapps/vipro-online-request-manager/dist/Guard.js
// module id = ZPXa
// module chunks = 0